import { defineElement, StyledElement } from '@webtides/element-js';

import styles from './modal-trigger.css';

class ModalTrigger extends StyledElement {
    constructor() {
        super({ styles: [styles] });
    }

    properties() {
        return {
            targetModal: '',
            parameters: {},
        };
    }

    events() {
        return {
            this: {
                click: event => {
                    var _targetModal = this.targetModal;
                    if (_targetModal.startsWith('#')) {
                        // Remove # at start WORKAROUND - TODO: https://jira.eurorad-it.de/browse/OHH-2898
                        _targetModal = _targetModal.substring(1);
                    }
                    this._modal = document.querySelector(`[modal-id="${_targetModal}"]`);
                    if (!this._modal) {
                        console.warn(`Could not find modal with id "${_targetModal}"`);
                        return;
                    }
                    event.preventDefault();
                    this._modal.open(this.parameters);
                },
            },
        };
    }
}

defineElement('modal-trigger', ModalTrigger);
